import { render, staticRenderFns } from "./tableLayoutWraper.vue?vue&type=template&id=33936ac4&"
import script from "./tableLayoutWraper.vue?vue&type=script&lang=js&"
export * from "./tableLayoutWraper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports